module.exports = __webpack_public_path__ + "img/star_normal.f516c90b.svg";